const B = "/cat/";
const img = (hash) => `${B}${hash}.jpeg`;
const oic = (name) => `/cat/official/${name}.png`;
export const whiteIcon = (src) => src.replace("/cat/official/", "/cat/white/");

export const CITIES = [
  { id: "dubai", name_ar: "دبي", name_en: "Dubai" },
  { id: "abudhabi", name_ar: "أبوظبي", name_en: "Abu Dhabi" },
  { id: "sharjah", name_ar: "الشارقة", name_en: "Sharjah" },
  { id: "ajman", name_ar: "عجمان", name_en: "Ajman" },
  { id: "rak", name_ar: "رأس الخيمة", name_en: "Ras Al Khaimah" },
  { id: "fujairah", name_ar: "الفجيرة", name_en: "Fujairah" },
  { id: "uaq", name_ar: "أم القيوين", name_en: "Umm Al Quwain" },
];

export const CATEGORIES = [
  {
    id: "furniture", name_ar: "الأثاث", name_en: "Furniture", banner: "https://images.unsplash.com/photo-1704040686510-b747ff423ebb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=75",
    image: oic("furniture"), thumb: oic("furniture"), hideCondition: false, business: false,
    subcategories: [
      { id: "chairs_sofas", name_ar: "الكراسي والكنبات", name_en: "Chairs & Sofas", image: oic("chairs_sofas") },
      { id: "tables", name_ar: "الطاولات", name_en: "Tables", image: oic("tables") },
      { id: "frames", name_ar: "البراويز", name_en: "Frames", image: oic("frames") },
      { id: "chandeliers", name_ar: "الثريات", name_en: "Chandeliers", image: oic("chandeliers") },
      { id: "artificial_plants", name_ar: "النباتات الصناعية", name_en: "Artificial Plants", image: oic("artificial_plants") },
      { id: "curtains", name_ar: "الستائر", name_en: "Curtains", image: oic("curtains") },
      { id: "garden", name_ar: "أثاث الحديقة", name_en: "Garden Furniture", image: oic("garden") },
      { id: "lighting", name_ar: "الإضاءات", name_en: "Lighting", image: oic("lighting") },
      { id: "carpets", name_ar: "السجاد", name_en: "Carpets", image: oic("carpets") },
      { id: "sets", name_ar: "طقم أثاث", name_en: "Furniture Sets", image: oic("sets") },
      { id: "gym_equipment", name_ar: "أجهزة ومعدات رياضية", name_en: "Gym & Fitness Equipment", image: oic("sports_equipment") },
      { id: "game_tables", name_ar: "طاولات ألعاب", name_en: "Game Tables", image: oic("game_tables") },
    ],
  },
  {
    id: "electronics", name_ar: "الأجهزة والإلكترونيات", name_en: "Electronics", banner: "https://images.unsplash.com/photo-1511317559916-56d5ddb62563?crop=entropy&cs=srgb&fm=jpg&w=1200&q=75",
    image: oic("electronics"), thumb: oic("electronics"), hideCondition: false, business: false,
    subcategories: [
      { id: "tvs", name_ar: "أجهزة التلفاز", name_en: "TVs", image: oic("tvs") },
      { id: "computers", name_ar: "الحاسب الآلي والطابعات", name_en: "Computers & Printers", image: oic("computers") },
      { id: "phones_watches", name_ar: "الهواتف والساعات الذكية", name_en: "Phones & Smartwatches", image: oic("phones_watches") },
      { id: "cameras", name_ar: "كاميرات التصوير", name_en: "Cameras", image: oic("cameras") },
      { id: "kitchen", name_ar: "أجهزة المطبخ", name_en: "Kitchen Appliances", image: oic("kitchen") },
      { id: "home_appliances", name_ar: "أجهزة منزلية", name_en: "Home Appliances", image: oic("home_appliances") },
      { id: "gaming", name_ar: "أجهزة ألعاب الفيديو", name_en: "Gaming Consoles", image: oic("gaming") },
    ],
  },
  {
    id: "antiques", name_ar: "التحف والمقتنيات", name_en: "Antiques & Collectibles", banner: "https://images.unsplash.com/photo-1758380742318-4074cce52ec4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=75",
    image: oic("antiques"), thumb: oic("antiques"), hideCondition: true, business: false,
    subcategories: [
      { id: "ant_furniture", name_ar: "أثاث قديم", name_en: "Antique Furniture", image: oic("ant_furniture") },
      { id: "ant_dishes", name_ar: "الأواني والصحون القديمة", name_en: "Vintage Dishes & Tableware", image: oic("ant_dishes") },
      { id: "ant_clocks", name_ar: "ساعات قديمة", name_en: "Antique Clocks & Watches", image: oic("ant_clocks") },
      { id: "ant_coins", name_ar: "عملات وأوراق نقدية", name_en: "Coins & Banknotes", image: oic("ant_coins") },
      { id: "ant_stamps", name_ar: "الطوابع", name_en: "Stamps", image: oic("ant_stamps") },
      { id: "ant_cameras", name_ar: "كاميرات قديمة", name_en: "Vintage Cameras", image: oic("ant_cameras") },
      { id: "ant_jewelry", name_ar: "مجوهرات وإكسسوارات", name_en: "Jewelry & Accessories", image: oic("ant_jewelry") },
      { id: "ant_books", name_ar: "كتب ومخطوطات", name_en: "Books & Manuscripts", image: oic("ant_books") },
      { id: "ant_radios", name_ar: "راديو وأجهزة إلكترونية قديمة", name_en: "Vintage Radios & Electronics", image: oic("ant_radios") },
      { id: "ant_rare", name_ar: "المقتنيات النادرة", name_en: "Rare Collectibles", image: oic("ant_rare") },
      { id: "ant_art", name_ar: "التحف", name_en: "Artifacts & Art", image: oic("ant_art") },
    ],
  },
  {
    id: "domestic_workers", name_ar: "مراكز العمالة المساعدة", name_en: "Domestic Workers Centers", banner: "https://images.unsplash.com/photo-1758523670739-0d26a3ee976d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=75",
    image: oic("domestic_workers"), thumb: oic("domestic_workers"), hideCondition: true, business: true,
    subcategories: [
      { id: "dw_housemaid", name_ar: "عامل منزلي / عاملة منزلية", name_en: "Housemaid / Houseboy", image: oic("dw_housemaid") },
      { id: "dw_babysitter", name_ar: "جليسة أطفال", name_en: "Babysitter", image: oic("dw_babysitter") },
      { id: "dw_nanny", name_ar: "مربية أطفال", name_en: "Nanny", image: oic("dw_nanny") },
      { id: "dw_cook", name_ar: "طباخ / طباخة", name_en: "Cook", image: oic("dw_cook") },
      { id: "dw_driver", name_ar: "سائق خاص / سائقة خاصة", name_en: "Private Driver", image: oic("dw_driver") },
      { id: "dw_gardener", name_ar: "مزارع", name_en: "Gardener", image: oic("dw_gardener") },
      { id: "dw_guard", name_ar: "حارس", name_en: "Guard", image: oic("dw_guard") },
      { id: "dw_butler", name_ar: "مدبر منزل / مدبرة منزل", name_en: "Housekeeper / Butler", image: oic("dw_butler") },
    ],
  },
  {
    id: "home_services", name_ar: "الخدمات المنزلية", name_en: "Home Services", banner: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?crop=entropy&cs=srgb&fm=jpg&w=1200&q=75",
    image: oic("home_services"), thumb: oic("home_services"), hideCondition: true, business: true,
    subcategories: [
      { id: "cleaning_company", name_ar: "شركة تنظيف المساكن", name_en: "House Cleaning Companies", image: oic("house_cleaning_company") },
      { id: "cleaning_daily", name_ar: "عمال و عاملات تنظيف يومي", name_en: "Daily Cleaning Workers", image: oic("daily_cleaning") },
      { id: "movers", name_ar: "شركات نقل الأثاث", name_en: "Furniture Movers", image: oic("movers") },
      { id: "laundry", name_ar: "مغاسل الملابس والسجاد", name_en: "Laundry & Carpet Cleaning", image: oic("laundry") },
      { id: "car_wash", name_ar: "غسيل السيارات", name_en: "Car Wash", image: oic("car_wash") },
      { id: "pet_care", name_ar: "خدمة العناية بالحيوانات الأليفة", name_en: "Pet Care Services", image: oic("pet_care") },
    ],
  },
];

export const CONDITIONS = [
  { id: "new", name_ar: "جديد", name_en: "New" },
  { id: "used", name_ar: "مستعمل", name_en: "Used" },
];

export const EMIRATES = [
  { ar: "أبوظبي", en: "Abu Dhabi" }, { ar: "دبي", en: "Dubai" }, { ar: "الشارقة", en: "Sharjah" }, { ar: "عجمان", en: "Ajman" },
  { ar: "أم القيوين", en: "Umm Al Quwain" }, { ar: "رأس الخيمة", en: "Ras Al Khaimah" }, { ar: "الفجيرة", en: "Fujairah" },
];

const emKey = (x) => String(x || "").toLowerCase().replace(/\s+/g, "");
export const findEmirate = (v) => EMIRATES.find((e) => [e.ar, emKey(e.en)].includes(v) || emKey(e.en) === emKey(v))
  || { uaq: EMIRATES[4], rak: EMIRATES[5] }[v];

export const STATUS_META = {
  pending_review: { ar: "قيد المراجعة الإدارية", en: "Under admin review", bg: "bg-amber-100", text: "text-amber-700" },
  pending_payment: { ar: "بانتظار دفع الرسوم", en: "Awaiting fee payment", bg: "bg-sky-100", text: "text-sky-700" },
  active: { ar: "نشط ومفعّل", en: "Active", bg: "bg-emerald-100", text: "text-emerald-700" },
  rejected: { ar: "مرفوض", en: "Rejected", bg: "bg-red-100", text: "text-red-700" },
  sold: { ar: "تم البيع", en: "Sold", bg: "bg-violet-100", text: "text-violet-700" },
};

const nm = (item, lang) => (item ? (lang === "en" ? item.name_en : item.name_ar) : "");

export const cityName = (id, lang) => nm(CITIES.find((c) => c.id === id), lang) || id;
export const categoryName = (id, lang) => nm(CATEGORIES.find((c) => c.id === id), lang) || id;
export const conditionName = (id, lang) => nm(CONDITIONS.find((c) => c.id === id), lang) || id;
export const subcategoryName = (catId, subId, lang) => {
  const cat = CATEGORIES.find((c) => c.id === catId);
  return nm(cat?.subcategories?.find((s) => s.id === subId), lang) || "";
};

export const formatPrice = (v, lang) =>
  new Intl.NumberFormat(lang === "en" ? "en-AE" : "ar-AE-u-nu-latn").format(Math.round(v || 0)) + (lang === "en" ? " AED" : " درهم إماراتي");

// Mobile PriceTag: service ads with no fixed price show "ابتداءً من X" (min_service_price) or "السعر عند الاتصال".
export const servicePriceText = (l, lang, fmt = formatPrice) =>
  !l?.price && (l?.category === "domestic_workers" || l?.category === "home_services")
    ? (l.min_service_price > 0 ? `${lang === "en" ? "From" : "ابتداءً من"} ${fmt(l.min_service_price, lang)}` : lang === "en" ? "Price on request" : "السعر عند الاتصال")
    : null;

// Cards (browse + My Ads) for labor centres / home services: no number, just a pointer to the detail page or "on call".
export const cardPriceNote = (l, lang) => {
  if (l?.category !== "domestic_workers" && l?.category !== "home_services") return null;
  const f = l.fields || {};
  const onCall = f.price_mode === "on_call" || f.hs_price_mode === "on_call" || (!(l.price > 0) && !(l.min_service_price > 0) && !(l.discount_percent > 0) && !l.dw_offers);
  return onCall ? (lang === "en" ? "Price on request" : "السعر عند الاتصال") : (lang === "en" ? "See prices in ad details" : "شاهد الأسعار في تفاصيل الإعلان");
};

export const discountPct = (l) =>
  l?.dw_offers ? Math.round(l.discount_percent || 0) : l?.original_price && l.original_price > l.price ? Math.round((1 - l.price / l.original_price) * 100) : 0;

// Localised ad text like the mobile adText(): ad.tr[lang][key] when present, else the original ("city" maps to listing.area).
export const adText = (l, key, lang) => {
  const tr = l?.tr?.[lang]?.[key];
  if (typeof tr === "string" && tr.trim()) return tr;
  return (key === "city" ? l?.area : l?.[key]) ?? "";
};

// "Emirate · City" in the visitor's language; the city is dropped when hidden or when it just repeats the emirate.
export const adPlace = (l, lang) => {
  const em = cityName(l?.city, lang);
  const city = adText(l, "city", lang);
  const norm = (x) => String(x || "").trim().toLowerCase().replace(/[أإآ]/g, "ا").replace(/\s+/g, "");
  const same = (x) => norm(x) === norm(em) || EMIRATES.some((e) => [e.ar, e.en].map(norm).includes(norm(x)) && [e.ar, e.en].map(norm).includes(norm(em)));
  return [em, city && !same(city) ? city : ""].filter(Boolean).join(" · ");
};

// Ad reference number exactly as the mobile app shows it: last 11 characters of ad_id, uppercase.
export const adRef = (id) => String(id || "").slice(-11).toUpperCase();
export const DESC_LABEL = (cat) => (cat === "domestic_workers" ? ["نبذة عن العامل", "About the worker"] : cat === "home_services" ? ["نبذة عن الخدمة", "About the service"] : ["نبذة عن المنتج", "About the product"]);
